/* eslint semi:0 */
import { nodes } from '../../utils/dom'
import { makeSafeFn } from '../../utils/fn'
import { externalScriptsConfig } from '../../organizedByType/config/externalScripts'
import { registerProvider } from '../../application/nm'
import { SELECTORS } from '../../config/preRenderedSelectorsConfig'
import { external } from '../../utils/script'

const NEWSCORP_ELEMENT_ID_PREFIX = 'newscorp-id-'

function initializeNewscorpEmbed(elementId, embedVideoId) {
  window.ballball_player_generate(elementId, 'in-id', embedVideoId, 'www.ballball.com')
}

function initializeNewscorpEmbeds(newscorpEmbedContainers) {
  for (let newscorpEmbedContainer of newscorpEmbedContainers) {
    const embedVideoId = newscorpEmbedContainer.dataset.id
    const elementId = `${NEWSCORP_ELEMENT_ID_PREFIX}${embedVideoId}`
    makeSafeFn(initializeNewscorpEmbed.part(elementId, embedVideoId)).invoke()
  }
}

export default function initNewscorp() {
  const newscorpEmbedContainers = nodes(SELECTORS.NEWSCORP_EMBED_CONTAINER)
  if (newscorpEmbedContainers.length) {
    const newscorpLoader = external.load({ name: externalScriptsConfig.newscorp.name })
    newscorpLoader(initializeNewscorpEmbeds.part(newscorpEmbedContainers))
  }
}

registerProvider({ initNewscorp })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/newscorp/newscorpEmbedProvider.js